import "./style.scss";
import React, { useEffect, useState } from "react";
import { ProjectList } from "./ProjectList";
import { TaskList } from "./TaskList";
import { AlarmList } from "./AlarmList";
import { LeftOutlined } from "@ant-design/icons";
import { useSideBarStore } from "../../../store/SideBarStore";
import { useInfoUser } from "../../../store/UserStore";
import { useLocation } from "react-router-dom";

const Dashboard = () => {
  const { user, languageMap } = useInfoUser();
  const location = useLocation();
  const { switchIsWorkManagementOptions, isWorkManagementOptions } =
    useSideBarStore((state) => state);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const backBtn = !isWorkManagementOptions ? (
    <a
      className="btn-back-to-work-management"
      onClick={switchIsWorkManagementOptions}
    >
      <LeftOutlined size={25} />
    </a>
  ) : null;
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <div
        className="dashboard-header"
        style={{ marginTop: isMobile ? "" : "16px" }}
      >
        {/* <div>{languageMap?.["event.dashboard.title"] ?? "Dashboard"}</div> */}
      </div>
      <div className="dashboard flex flex-col">
        {location.pathname === "/work-management/dashboard" ? (
          <div className="project" style={{ border: isMobile ? "none" : "" }}>
            <ProjectList isMobile={isMobile} backBtn={backBtn} />
          </div>
        ) : (
          <div className="task-alarm flex">
            {location.pathname === "/work-management/task" ? (
              <TaskList isMobile={isMobile} backBtn={backBtn} />
            ) : (
              <AlarmList isMobile={isMobile} backBtn={backBtn} />
            )}
          </div>
        )}
      </div>
    </>
  );
};
export { Dashboard };
